import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const { foundProducts, loading } = useAppStateSelector(state => ({ 
        foundProducts: state.response.products?.total > 0, 
        loading: state.loading 
    }))

    return (
        <div class="ns-serp" data-nosto-element={type}>
            { children({ loading, foundProducts }) }
        </div>
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}

